// "use client";
// import Select from "react-select";
// import makeAnimated from 'react-select/animated';
// import { useState, useEffect } from "react";
// import cities from "../../../json/cities/cities_CA";
// import Styles from "./Styles";

// const LocationSelect = ({ onChange, value, placeholder, id, name, required, missingRequired }) => {
//   const animatedComponents = makeAnimated();

//   // State to track if we are on the client side
//   const [isClient, setIsClient] = useState(false);
//   const [data, setData] = useState([]);
//   const [error, setError] = useState(null);
//   const [isClearable, setIsClearable] = useState(true);
//   const [isSearchable, setIsSearchable] = useState(true);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isRtl, setIsRtl] = useState(false);

//   // Set isClient to true after component mounts (client-side)
//   useEffect(() => {
//     setIsClient(true);
//   }, []);

//   useEffect(() => {
//     const getData = async () => {
//       try {
//         const array = cities.map((location) => ({
//           value: `${location.name}, ${location.state}, ${location.country}`,
//           label: `${location.name}, ${location.state}, ${location.country}`,
//         }));
//         setData(array);
//         setError(null);
//       } catch (error) {
//         setError(error.message);
//         setData([]);
//       }
//     };
//     getData();
//   }, []);

//   // Only render Select component if we are on the client
//   if (!isClient) {
//     return null; // or a fallback UI if desired
//   }
// else {
//   return (
//     <Select
//       required={required}
//       className={`w-full ${missingRequired ? 'border border-red-400 dark:border-red-600' : ''} dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
//       classNamePrefix="select"
//       isDisabled={isDisabled}
//       isLoading={isLoading}
//       isClearable={isClearable}
//       isRtl={isRtl}
//       isSearchable={isSearchable}
//       name={name}
//       id={id}
//       onChange={onChange}
//       value={value}
//       options={data}
//       components={animatedComponents}
//       placeholder={placeholder}
//       styles={Styles()}
//     />
//   );}
// };

// export default LocationSelect;















// "use client" 
// import Select from "react-select"
// import makeAnimated from 'react-select/animated'

// import { useState, useEffect } from "react"
// import citiesCA from "../../../json/geography/cities_CA"
// import citiesUS from "../../../json/geography/cities_US"
// import statesCA from "../../../json/geography/states_CA"
// import statesUS from "../../../json/geography/states_US"
// import countries from "../../../json/geography/countries_ALL"
// import Styles from "./Styles"
// import { humanizeString } from "@/utils/frontend/stringOps"

// const LocationSelect = ({onChange, value, placeholder, id, name, required, missingRequired, zoomLevel, selectedCountry, selectedState, isDisabled}) => {

//      console.log("UZRCNTRY", selectedCountry)
//      const animatedComponents = makeAnimated();

//      const [isClient, setIsClient] = useState(false)
//      const [data, setData] = useState(null);
//      const [loading, setLoading] = useState(true);
//      const [error, setError] = useState(null);
//      const [isClearable, setIsClearable] = useState(true);
//      const [isSearchable, setIsSearchable] = useState(true);

//      const [isLoading, setIsLoading] = useState(false);
//      const [isRtl, setIsRtl] = useState(false);
//      const [states, setStates] = useState(statesCA)
//      const [cities, setCities] = useState(citiesCA)



//      // useEffect(() => {
//      // setIsClient(true)
//      // const getData = async () => {

//      //      try {

//      //        let array = []

//      //        let locationsToRender = zoomLevel === 'COUNTRIES' ? countries : cities

          
//      //        // frontend locations

//      //        locationsToRender.forEach(location => {
//      //                if (zoomLevel === 'COUNTRIES') {
//      //                     let obj = {value: `${location.country}`, label: `${humanizeString(location.country)}`}
//      //                     array.push(obj)
//      //                }

//      //                else {
//      //                     let obj = {value: `${location.city}, ${location.state}, ${location.country}`, label: `${location.city}, ${location.state}, ${location.country}`}
//      //                     array.push(obj)
//      //                }
//      //          }, setData(array));
    
//      //      // setData(array);
//      //      setError(null);
//      //      return data
//      //      } catch(error) {
//      //      setError(error.message);
//      //      setData(null);
//      //      } finally {
//      //      setLoading(false);
//      //      }  
//      // }

//      // const getCities = async () =>{
//      //      if (selectedCountry?.toUpperCase() === 'CANADA') { 
//      //           setCities(citiesCA)
//      //      }
//      //      else if (selectedCountry?.toUpperCase() === 'UNITED_STATES') {
//      //           setCities(citiesUS)
//      //      }
//      // }

//      // getCities()
//      // getData()
//      // }, [selectedCountry])


//      useEffect(() => {
//           setIsClient(true);
//       }, []);
  
//       // Update cities when selectedCountry changes
//       useEffect(() => {
//           if (selectedCountry?.toUpperCase() === "CANADA") {
//                setStates(statesCA)
//           //     setCities(citiesCA);
//           } else if (selectedCountry?.toUpperCase() === "UNITED_STATES") {
//                setStates(statesUS)
//           //     setCities(citiesUS);
//           }
//       }, [selectedCountry]);
  
//       // Update data based on cities or zoomLevel changes
//      //  useEffect(() => {
//      //      const getData = async () => {
//      //          try {
//      //              let locationsToRender;
//      //              if (zoomLevel === "COUNTRIES"){locationsToRender = countries}
//      //              else if(zoomLevel === 'STATES') {locationsToRender = states}
//      //              else {locationsToRender = cities} 
//      //              const array = locationsToRender.map((location) => {
//      //                  if (zoomLevel === "COUNTRIES") {
//      //                      return { value: `${location.country}`, label: `${humanizeString(location.country)}` };
//      //                  }
//      //                else if (zoomLevel === 'STATES') {
//      //                     return { value: `${location.state}`, label: `${humanizeString(location.state)}` };
//      //                     }
//      //                   else if (zoomLevel === 'CITIES') {
//      //                     if (location.state.toUpperCase() === selectedState?.toUpperCase()) {
//      //                          return {
//      //                               value: `${location.city}, ${location.state}, ${location.country}`,
//      //                               label: `${location.city}, ${location.state}, ${location.country}`,
//      //                           };
//      //                     }
//      //                     else { return null}
                         
//      //                  }
//      //              });
//      //              setData(array);
//      //              setError(null);
//      //          } catch (error) {
//      //              setError(error.message);
//      //              setData([]);
//      //          }
//      //      };
  
//      //      getData();
//      //  }, [cities, zoomLevel]);
//      useEffect(() => {
//           const getData = async () => {
//               try {
//                   let locationsToRender;
//                   if (zoomLevel === "COUNTRIES") {
//                       locationsToRender = countries;
//                   } else if (zoomLevel === "STATES") {
//                       locationsToRender = states;
//                   } else {
//                       locationsToRender = cities;
//                   }
      
//                   const array = locationsToRender
//                       .map((location) => {
//                           if (zoomLevel === "COUNTRIES") {
//                               return {
//                                   value: `${location.country}`,
//                                   label: `${humanizeString(location.country)}`,
//                               };
//                           } else if (zoomLevel === "STATES") {
//                               return {
//                                   value: `${location.state}`,
//                                   label: `${humanizeString(location.state)}`,
//                               };
//                           } else if (zoomLevel === "CITIES") {
//                               // Only include cities that match the selected state
//                               if (
//                                   location.state.toUpperCase() ===
//                                   selectedState?.toUpperCase()
//                               ) {
//                                   return {
//                                       value: `${location.city}`,
//                                       label: `${location.city}`,
//                                   };
//                               }
//                               // Return null instead of empty string to filter it out
//                               return null;
//                           }
//                           return null; // Return null for any other cases
//                       })
//                       .filter((item) => item !== null); // Remove any null entries
      
//                   setData(array);
//                   setError(null);
//               } catch (error) {
//                   setError(error.message);
//                   setData([]);
//               }
//           };
      
//           getData();
//       }, [zoomLevel, selectedState]);

//      if (!isClient){
//           return null;
//      }


//      return (
  
//           <Select
        
//           required={required}
//             // className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600'} dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start`}
//             className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600'} dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}

//           //   cacheOptions={true} 
//           //   defaultOptions={true}

//             classNamePrefix="select"
//           //   defaultValue={colourOptions[0]}
//             isDisabled={isDisabled}
//             isLoading={isLoading}
//             isClearable={isClearable}
//             isRtl={isRtl}
//             isSearchable={isSearchable}
//             name={name}
//             id={id}
//             onChange={onChange}
//             value={value}
//             options={data}
//           //   components={{ MenuList: CustomMenuList, ...animatedComponents }}
//           components={animatedComponents}
//             placeholder={placeholder}
//             styles={Styles()}
//           />
    
  
     
//      )
// }

// export default LocationSelect








/*-------------------------------------------------------------
  unused as of 2026-01-28, replaced by LocationSelectGeoNames
-------------------------------------------------------------*/
import { useState, useEffect } from "react";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import citiesCA from "../../../json/geography/cities_CA";
import citiesUS from "../../../json/geography/cities_US";
import statesCA from "../../../json/geography/states_CA";
import statesUS from "../../../json/geography/states_US";
import countries from "../../../json/geography/countries_ALL";
import { humanizeString } from "@/utils/frontend/stringOps";
import useSelectStyles from "./Styles";

const LocationSelect = ({
  onChange,
  value,
  placeholder,
  id,
  name,
  required,
  missingRequired,
  zoomLevel,
  selectedCountry,
  selectedState,
  isDisabled,
  onKeyDown,
  filterHasMarketplaceAccess=true
}) => {
  const animatedComponents = makeAnimated();

  const [data, setData] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [error, setError] = useState(null);
  const [isClient, setIsClient] = useState(false);


    useEffect(() => {
    setIsClient(true);
    }, []);
  // Populate states based on selected country
  useEffect(() => {
    if (!selectedCountry) return;

    if (selectedCountry.toUpperCase() === "CANADA") {
      setStates(statesCA);
      setCities([]); // Reset cities when country changes
    } else if (selectedCountry.toUpperCase() === "UNITED_STATES") {
      setStates(statesUS);
      setCities([]); // Reset cities when country changes
    }
  }, [selectedCountry]);

  // Populate cities based on selected state
  useEffect(() => {
    if (!selectedState || !selectedCountry) return;

    if (selectedCountry.toUpperCase() === "CANADA") {
      // console.log("SELECTEDSTATE", selectedState)
      setCities(citiesCA.filter(city => city.state?.toUpperCase().split(' ').join('_') === selectedState.toUpperCase().split(' ').join('_')));
    } else if (selectedCountry.toUpperCase() === "UNITED_STATES") {
      setCities(citiesUS.filter(city => city.state?.toUpperCase() === selectedState.toUpperCase()));
    }
  }, [selectedState, selectedCountry]);

  // Populate dropdown options based on zoomLevel
  useEffect(() => {
    try {
      let options = [];
      if (zoomLevel === "COUNTRIES") {
        // if only displaying has_marketplace_access country (countries that currently have access to job and talent marketplace)
        countries = filterHasMarketplaceAccess === true ? countries.filter(c => c.has_marketplace_access===true) : countries
        options = countries.map(country => ({
          value: country.country,
          label: humanizeString(country.country),
        }));

      } else if (zoomLevel === "STATES") {
        options = states.map(state => ({
          value: state.state,
          label: humanizeString(state.state),
        }));
      } else if (zoomLevel === "CITIES") {
        options = cities.map(city => ({
          value: city.city,
          label: city.city,
        }));
      }
      setData(options);
    } catch (error) {
      setError(error.message);
      setData([]);
    }
  }, [zoomLevel, states, cities]);

    if (!isClient) {
    return null; // or a fallback UI if desired
  }
  return (
    <Select
    onKeyDown={onKeyDown}
      required={required}
      className={`w-full ${
        missingRequired && "border border-red-400 dark:border-red-600"
      } dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
      classNamePrefix="select"
      isDisabled={isDisabled}
      isClearable
      isSearchable
      name={name}
      id={id}
      onChange={onChange}
      value={value}
      options={data}
      // components={animatedComponents}
      placeholder={placeholder}
      styles={useSelectStyles()}
    />
  );
};

export default LocationSelect;